import axios from 'axios';
import { getAuthHeaders, getAuthHeadersWithContentType } from '../utils/auth';

const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:8001';

export interface BalanceResponse {
  balance: number;
  currency: string;
}

export const getBalance = async (): Promise<BalanceResponse> => {
  const response = await axios.get<BalanceResponse>(`${ADMIN_API_URL}/billing/balance`, {
    headers: await getAuthHeaders()
  });
  return response.data;
};

export const createYooMoneyInvoice = async (amount: number): Promise<{ payment_url: string }> => {
  const response = await axios.post<{ payment_url: string }>(`${ADMIN_API_URL}/billing/payments/yoomoney`, {
    amount,
  }, {
    headers: await getAuthHeadersWithContentType()
  });
  return response.data;
}; 
